/**
 * The slot registrations of `web/import` (CS r4a deliverable 109): the sidebar's "Import from
 * Notion" entry (`shell.workspace.import`) and the Settings button (`settings.sections.import`).
 * The Tidy pill (`header.pills.tidy`) follows the stat block's.
 * `apps/web/src/editor-services/slots.ts` collects them as `SLOT_MODULES['web/import']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { SettingsImportSection, SidebarImportEntry } from './entry.js';
import { TidyPill } from './tidy-pill.js';

export const owner: WorkPackageId = '2.B-2';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'shell.workspace', order: 10, owner: '2.B-2', component: SidebarImportEntry },
  { slot: 'settings.sections', order: 10, owner: '2.B-2', component: SettingsImportSection },
  { slot: 'header.pills', order: 80, owner: '2.B-2', component: TidyPill },
];
